// extracted by mini-css-extract-plugin
module.exports =  {"count":"jKmbkzr","alias":"CPh4siu"};